import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PawktLogo } from "@/components/pawkt/PawktLogo";

export default function NotFound() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center text-center" data-testid="not-found-page">
      <PawktLogo variant="splash" />
      <p className="mt-6 font-display text-5xl font-extrabold tracking-tight text-pawkt-text">404</p>
      <p className="mt-2 font-display text-lg font-bold text-pawkt-text">Page not found</p>
      <p className="mt-1 max-w-sm text-sm text-pawkt-text-secondary">
        The page you’re looking for doesn’t exist or may have moved.
      </p>
      <Link
        to="/dashboard"
        data-testid="not-found-home-btn"
        className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-bold text-white shadow-purpleGlow transition-colors hover:bg-pawkt-primary-hover"
      >
        <ArrowLeft className="h-4 w-4" /> Back to dashboard
      </Link>
    </div>
  );
}
